export const FETCH_AUDIENCES_FAILURE = "FETCH_AUDIENCES_FAILURE";
export const FETCH_AUDIENCES_REQUEST = "FETCH_AUDIENCES_REQUEST";
export const FETCH_AUDIENCES_SUCCESS = "FETCH_AUDIENCES_SUCCESS";